module.exports = "<p>brokrage-request-view works!</p>\r\n"